export default __webpack_public_path__ + "static/water_b.d3b85d96bacd606e7a5dfa67769b58cb.svg";